import { getColorScheme } from '@leaflink/stash-utils/colorScheme';

export { getColorScheme };
export default getColorScheme;
